module.exports = __webpack_public_path__ + "img/T1A_xh_7.8fe5534f.png";